import React from "react";
import { SurveyContainerStyled } from "./styles.web";
const Survey = React.memo(({ renderHead, renderContent }) => {
    return (React.createElement(SurveyContainerStyled, null,
        renderHead,
        React.createElement("div", { className: "content" }, renderContent)));
});
export default Survey;
